import { jsx as t, jsxs as r, Fragment as he } from "react/jsx-runtime";
import { withManagedProps as x } from "@made-people/managed-props";
import { withZod as m } from "@made-people/react-prop-guard";
import { useEffect as O, createContext as me, useState as w, useContext as be } from "react";
import { useNewsletterMethod as ge } from "@made-people/grease-newsletter";
import { z as n } from "zod";
import * as I from "@radix-ui/react-checkbox";
import { termsAndConditionsStyling as Ne, inputFieldStyling as Z, signupListsStyling as ye, errorStyling as ve, newsletterTemplate1Styling as we, newsletterTemplate2Styling as z, newsletterTemplate3Styling as q, newsletterTemplate4Styling as A } from "./index-blueprint.es.js";
import { AnimatePresence as T, motion as g } from "motion/react";
import { useTranslate as L } from "@made-people/grease-translations";
import { Button as Se } from "@made-people/blueprint-button";
import { componentWrapperSchema as S, ComponentWrapper as V } from "@made-people/blueprint-component-wrapper";
import { badgeSchema as G, Badge as J } from "@made-people/blueprint-badge";
import { responsiveImageSchema as K, ResponsiveImage as Q } from "@made-people/blueprint-responsive-image";
import "@made-people/blueprint";
const U = () => /* @__PURE__ */ t(T, { children: /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    fill: "none",
    width: "16",
    height: "16",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ t(
      g.path,
      {
        initial: { pathLength: 0 },
        animate: { pathLength: 1 },
        exit: { pathLength: 0 },
        transition: {
          type: "tween",
          duration: 0.2,
          ease: "easeIn"
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
      }
    )
  }
) }), X = n.object({
  text: n.string().optional(),
  checkIcon: n.custom().optional(),
  requireCheckbox: n.boolean().optional(),
  variants: n.custom().optional(),
  styling: n.custom().optional().describe("If you want to override the default styling")
}), W = m(X, (s) => {
  const { setChecked: c, checked: o } = N(), l = (s.styling ?? Ne).styles(s.variants), a = s.checkIcon ?? /* @__PURE__ */ t(U, {});
  return s.text ? /* @__PURE__ */ r("div", { className: l.termsAndConditionsWrapper, children: [
    s.requireCheckbox && /* @__PURE__ */ t(
      I.Root,
      {
        className: l.checkbox,
        id: "checkbox",
        onCheckedChange: () => c(!o),
        children: /* @__PURE__ */ t(I.Indicator, { className: l.checkboxIndicator, children: a })
      }
    ),
    /* @__PURE__ */ t("label", { htmlFor: "checkbox", className: l.termsAndConditionsBody, children: /* @__PURE__ */ t(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: s.text
        }
      }
    ) })
  ] }) : null;
}), H = n.object({
  floatingLabel: n.string().optional(),
  placeholder: n.string().optional(),
  variants: n.custom().optional(),
  styling: n.custom().optional().describe("If you want to override the default styling")
}), P = m(H, (s) => {
  const { emailAddress: c, setEmailAddress: o, subscribed: e } = N(), a = (s.styling ?? Z).styles(s.variants), d = L(), u = (p) => {
    const h = p.target.value;
    o && o(h);
  };
  O(() => {
    e && o("");
  }, [e, o]);
  let i = "";
  return s.floatingLabel ? i = "" : s.placeholder ? i = d(s.placeholder) : i = "", /* @__PURE__ */ r("div", { className: a.inputWrapper, children: [
    /* @__PURE__ */ t(
      "input",
      {
        id: "email",
        onChange: u,
        value: c,
        type: "email",
        placeholder: i,
        className: a.inputField
      }
    ),
    s.floatingLabel && /* @__PURE__ */ t("label", { htmlFor: "email", className: a.inputLabel, children: d(s.floatingLabel) })
  ] });
}), Y = n.object({
  body: n.string().optional(),
  className: n.string().optional()
}), j = m(
  Y,
  (s) => {
    if (!s.body)
      return null;
    const c = L();
    return /* @__PURE__ */ t("p", { className: s.className, children: c(s.body) });
  }
), ee = n.object({
  lists: n.array(n.string()).optional(),
  variants: n.custom().optional(),
  checkIcon: n.custom().optional()
}), E = m(ee, (s) => {
  const { setChecked: c, checked: o } = N();
  if (!s.lists)
    return null;
  const e = ye.styles(s.variants), l = s.checkIcon ?? /* @__PURE__ */ t(U, {});
  return /* @__PURE__ */ t("div", { className: e.checkbox, children: s.lists.map((a) => /* @__PURE__ */ r("div", { className: e.checkbox, children: [
    /* @__PURE__ */ t(
      I.Root,
      {
        className: e == null ? void 0 : e.checkbox,
        id: `checkbox-${a}`,
        onCheckedChange: () => c(!o),
        checked: o,
        children: /* @__PURE__ */ t(I.Indicator, { className: e == null ? void 0 : e.checkboxIndicator, children: l })
      }
    ),
    /* @__PURE__ */ t("label", { htmlFor: `checkbox-${a}`, className: e == null ? void 0 : e.label, children: a })
  ] }, a)) });
}), te = n.object({
  buttonLabel: n.string().optional(),
  buttonIcon: n.custom().optional(),
  className: n.string().optional(),
  variants: n.custom().optional(),
  confetti: n.boolean().optional()
}), B = m(
  { schema: te, defaultProps: { confetti: !1 } },
  (s) => {
    const { loading: c, handleSubmit: o, subscribed: e } = N(), l = s.confetti && e;
    return /* @__PURE__ */ t("div", { className: s.className, children: /* @__PURE__ */ t(
      Se,
      {
        as: "button",
        label: s.buttonLabel,
        onClick: o,
        progress: c ? "loading" : "default",
        variants: s.variants,
        confetti: l
      }
    ) });
  }
), xe = n.record(n.string(), n.unknown()), _ = n.object({
  className: n.string().optional(),
  termsAndConditions: X.optional(),
  inputField: H.optional(),
  phoneNumberField: H.optional(),
  submitButton: te.optional(),
  subscriptionSuccess: Y.optional(),
  lists: ee.optional(),
  // Allow passing custom attributes to the subscribe function
  subscribeAttributes: n.record(n.string(), n.unknown()).optional()
}), ke = (s) => {
  if (s.length === 0)
    return;
  const c = /^[\d+\-()\s]+$/.test(s), o = /\d/.test(s);
  if (!(c && o))
    return "Newsletter_Invalid_Phone_Number";
  const e = s.replace(/\D/g, "").length;
  if (e < 7 || e > 15)
    return "Newsletter_Invalid_Phone_Number";
}, Ce = n.union([
  n.string(),
  n.array(n.string()),
  n.function().args(n.custom()).returns(n.union([n.string(), n.array(n.string())]))
]), Qe = n.object({
  listId: Ce.optional(),
  requiresCheckbox: n.boolean().optional(),
  children: n.custom(),
  subscribeAttributes: xe.optional()
}), ne = me(void 0), se = (s) => {
  const { loading: c, error: o, setError: e, execute: l } = ge("subscribe"), [a, d] = w(!s.requiresCheckbox), [u, i] = w(!1), [p, h] = w(""), [b, de] = w(""), [f, F] = w(void 0), D = (v) => {
    de(v), f && F(void 0);
  }, ue = n.string().email().safeParse(p).success && a, pe = {
    error: o,
    phoneError: f,
    loading: c,
    checked: a,
    subscribed: u,
    setChecked: d,
    emailAddress: p,
    setEmailAddress: h,
    phoneNumber: b,
    setPhoneNumber: D,
    handleSubmit: async (v) => {
      if (v == null || v.preventDefault(), !a) {
        const $ = new Error("Newsletter_Method_Agree");
        throw e($), $;
      }
      const R = ke(b);
      if (R) {
        F(R);
        return;
      }
      if (F(void 0), ue) {
        if (typeof s.listId == "function")
          throw new Error("listId getter function isn't implemented yet");
        await l({
          email: p,
          attributes: {
            ...s.subscribeAttributes || {},
            listId: s.listId,
            phoneNumber: b || void 0
          }
        }).then(() => {
          i(!0), h(""), D(""), F(void 0);
        }).catch(() => i(!1)).finally(() => {
          setTimeout(() => {
            i(!1);
          }, 5e3);
        });
      }
    }
  };
  return /* @__PURE__ */ t(ne.Provider, { value: pe, children: s.children });
};
se.displayName = "FormStateProvider";
const N = () => {
  const s = be(ne);
  if (!s)
    throw new Error("useFormState must be used inside a <FormStateProvider />");
  return s;
}, k = n.object({
  heading: n.string().optional(),
  headingTag: n.enum(["h3", "h4", "h5", "h6"]).optional(),
  className: n.string().optional()
}), M = m(k, (s) => {
  const { heading: c, headingTag: o, className: e } = s;
  if (!c)
    return null;
  const l = L();
  return /* @__PURE__ */ t(o || "h3", { className: e, children: /* @__PURE__ */ t("span", { children: l(c) }) });
}), C = n.object({
  text: n.string().optional(),
  className: n.string().optional()
}), y = m(C, (s) => {
  const { text: c, className: o } = s;
  return c ? /* @__PURE__ */ t("p", { className: o, children: c }) : null;
}), Fe = n.object({
  error: n.custom().optional(),
  variants: n.custom().optional(),
  errorIcon: n.custom().optional()
}), Ae = m(Fe, (s) => {
  const c = ve.styles(s.variants);
  return /* @__PURE__ */ t(he, { children: s.error && /* @__PURE__ */ t("div", { className: c.wrapper, children: /* @__PURE__ */ t("p", { className: c.body, children: s.error.message }) }) });
}), ie = n.object({
  variants: n.custom().optional(),
  template: n.literal("template1").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: _.optional()
}), Ie = x(
  "NewsletterTemplate1",
  m(ie, ({ variants: s, heading: c, text: o, form: e }) => {
    const l = we.styles(s), { subscribed: a, error: d } = N();
    return /* @__PURE__ */ r("section", { className: l.base, children: [
      /* @__PURE__ */ t(M, { className: l.heading, ...c }),
      /* @__PURE__ */ t(y, { className: l.body, text: o }),
      !a && /* @__PURE__ */ r("form", { className: l.form, children: [
        /* @__PURE__ */ r("div", { className: l.inputWrapper, children: [
          /* @__PURE__ */ t(P, { ...e == null ? void 0 : e.inputField }),
          /* @__PURE__ */ t(
            B,
            {
              className: l.buttonWrapper,
              ...e == null ? void 0 : e.submitButton
            }
          )
        ] }),
        /* @__PURE__ */ t(W, { ...e == null ? void 0 : e.termsAndConditions }),
        /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists }),
        /* @__PURE__ */ t(Ae, { error: d })
      ] }),
      a && /* @__PURE__ */ t(j, { ...e == null ? void 0 : e.subscriptionSuccess })
    ] });
  })
), ae = n.object({
  variants: n.custom().optional(),
  template: n.literal("template2").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: _.optional(),
  layout: S.shape.layout.optional()
}), Te = x(
  "NewsletterTemplate2",
  m(
    ae,
    ({ variants: s, heading: c, text: o, form: e, layout: l }) => {
      const a = z.main.styles(s), { subscribed: d, error: u } = N(), i = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ t(
        V,
        {
          className: a.wrapper,
          background: a.background,
          layout: l,
          children: /* @__PURE__ */ r("div", { className: a.container, children: [
            /* @__PURE__ */ t("div", { className: a.headingWrapper, children: /* @__PURE__ */ t(M, { className: a.heading, ...c }) }),
            /* @__PURE__ */ r("div", { className: a.formWrapper, children: [
              /* @__PURE__ */ r(T, { mode: "wait", children: [
                u && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(y, { className: a.body, text: u.message }) }, "error"),
                d && !u && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(
                  j,
                  {
                    className: a.body,
                    ...e == null ? void 0 : e.subscriptionSuccess
                  }
                ) }, "success"),
                !d && !u && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(y, { className: a.body, text: o }) }, "text")
              ] }),
              /* @__PURE__ */ r("form", { className: a.form, children: [
                /* @__PURE__ */ r("div", { className: a.fieldsWrapper, children: [
                  /* @__PURE__ */ t(
                    P,
                    {
                      styling: z.inputField,
                      ...e == null ? void 0 : e.inputField
                    }
                  ),
                  /* @__PURE__ */ t(
                    B,
                    {
                      className: a.buttonWrapper,
                      ...e == null ? void 0 : e.submitButton
                    }
                  )
                ] }),
                /* @__PURE__ */ t(
                  W,
                  {
                    styling: z.termsAndConditions,
                    ...e == null ? void 0 : e.termsAndConditions
                  }
                ),
                /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
              ] })
            ] })
          ] })
        }
      );
    }
  )
), le = n.object({
  variants: n.custom().optional(),
  template: n.literal("template3").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: _.optional(),
  badge: G.optional(),
  image: K.optional(),
  layout: S.shape.layout.optional()
}).merge(S), Le = x(
  "NewsletterTemplate3",
  m(
    le,
    ({ variants: s, heading: c, text: o, form: e, badge: l, image: a, layout: d, ...u }) => {
      const i = q.main.styles(s), { subscribed: p, error: h } = N(), b = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ r(
        V,
        {
          className: i.wrapper,
          background: i.background,
          layout: { ...d },
          ...u,
          children: [
            /* @__PURE__ */ r("div", { className: i.container, children: [
              /* @__PURE__ */ r("div", { className: i.headingWrapper, children: [
                (l == null ? void 0 : l.label) && /* @__PURE__ */ t(J, { ...l, className: i.badge }),
                /* @__PURE__ */ t(M, { className: i.heading, ...c })
              ] }),
              /* @__PURE__ */ r("div", { className: i.formWrapper, children: [
                /* @__PURE__ */ r(T, { mode: "wait", children: [
                  h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: h.message }) }, "error"),
                  p && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(
                    j,
                    {
                      className: i.body,
                      ...e == null ? void 0 : e.subscriptionSuccess
                    }
                  ) }, "success"),
                  !p && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: o }) }, "text")
                ] }),
                /* @__PURE__ */ r("form", { className: i.form, children: [
                  /* @__PURE__ */ r("div", { className: i.fieldsWrapper, children: [
                    /* @__PURE__ */ t(
                      P,
                      {
                        styling: q.inputField,
                        ...e == null ? void 0 : e.inputField
                      }
                    ),
                    /* @__PURE__ */ t(
                      B,
                      {
                        className: i.buttonWrapper,
                        ...e == null ? void 0 : e.submitButton
                      }
                    )
                  ] }),
                  /* @__PURE__ */ t(
                    W,
                    {
                      styling: q.termsAndConditions,
                      ...e == null ? void 0 : e.termsAndConditions
                    }
                  ),
                  /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(
              Q,
              {
                ...a,
                displaySize: (a == null ? void 0 : a.displaySize) ?? {
                  mobile: "50vw",
                  tablet: "30vw",
                  desktop: "30vw"
                },
                className: i.image
              }
            )
          ]
        }
      );
    }
  )
), We = n.object({
  floatingLabel: n.string().optional(),
  placeholder: n.string().optional(),
  variants: n.custom().optional(),
  styling: n.custom().optional().describe("If you want to override the default styling")
}), Pe = m(We, (s) => {
  const { phoneNumber: c, setPhoneNumber: o, subscribed: e, phoneError: l } = N(), d = (s.styling ?? Z).styles(s.variants), u = L(), i = (h) => {
    const b = h.target.value;
    o && o(b);
  };
  O(() => {
    e && o("");
  }, [e, o]);
  let p = "";
  return s.floatingLabel ? p = "" : s.placeholder ? p = u(s.placeholder) : p = "", /* @__PURE__ */ r("div", { className: d.inputWrapper, children: [
    /* @__PURE__ */ t(
      "input",
      {
        id: "phoneNumber",
        onChange: i,
        value: c,
        type: "tel",
        placeholder: p,
        "aria-invalid": !!l,
        className: d.inputField
      }
    ),
    s.floatingLabel && /* @__PURE__ */ t("label", { htmlFor: "phoneNumber", className: d.inputLabel, children: u(s.floatingLabel) }),
    l && /* @__PURE__ */ t("p", { role: "alert", className: d.inputError, children: u(l) })
  ] });
}), oe = n.object({
  variants: n.custom().optional(),
  template: n.literal("template4").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: _.optional(),
  badge: G.optional(),
  image: K.optional(),
  layout: S.shape.layout.optional()
}).merge(S), je = x(
  "NewsletterTemplate4",
  m(
    oe,
    ({ variants: s, heading: c, text: o, form: e, badge: l, image: a, layout: d, ...u }) => {
      const i = A.main.styles(s), { subscribed: p, error: h } = N(), b = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ r(
        V,
        {
          className: i.wrapper,
          background: i.background,
          layout: { ...d },
          ...u,
          children: [
            /* @__PURE__ */ r("div", { className: i.container, children: [
              /* @__PURE__ */ r("div", { className: i.headingWrapper, children: [
                (l == null ? void 0 : l.label) && /* @__PURE__ */ t(J, { ...l, className: i.badge }),
                /* @__PURE__ */ t(M, { className: i.heading, ...c })
              ] }),
              /* @__PURE__ */ r("div", { className: i.formWrapper, children: [
                /* @__PURE__ */ r(T, { mode: "wait", children: [
                  h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: h.message }) }, "error"),
                  p && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(
                    j,
                    {
                      className: i.body,
                      ...e == null ? void 0 : e.subscriptionSuccess
                    }
                  ) }, "success"),
                  !p && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: o }) }, "text")
                ] }),
                /* @__PURE__ */ r("form", { className: i.form, children: [
                  /* @__PURE__ */ r("div", { className: "flex flex-col gap-4", children: [
                    /* @__PURE__ */ t("div", { className: i.fieldsWrapper, children: /* @__PURE__ */ t(
                      P,
                      {
                        styling: A.inputField,
                        ...e == null ? void 0 : e.inputField
                      }
                    ) }),
                    (e == null ? void 0 : e.phoneNumberField) && /* @__PURE__ */ t("div", { className: i.fieldsWrapper, children: /* @__PURE__ */ t(
                      Pe,
                      {
                        styling: A.inputField,
                        ...e.phoneNumberField
                      }
                    ) }),
                    /* @__PURE__ */ t("div", { className: i.buttonWrapper, children: /* @__PURE__ */ t(B, { ...e == null ? void 0 : e.submitButton }) })
                  ] }),
                  /* @__PURE__ */ t(
                    W,
                    {
                      styling: A.termsAndConditions,
                      ...e == null ? void 0 : e.termsAndConditions
                    }
                  ),
                  /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(
              Q,
              {
                ...a,
                displaySize: (a == null ? void 0 : a.displaySize) ?? {
                  mobile: "50vw",
                  tablet: "30vw",
                  desktop: "30vw"
                },
                className: i.image
              }
            )
          ]
        }
      );
    }
  )
), ce = n.union([
  ie,
  ae,
  le,
  oe
]), re = m(
  ce,
  (s) => {
    switch (s.template) {
      case "template1":
        return /* @__PURE__ */ t(Ie, { ...s });
      case "template2":
        return /* @__PURE__ */ t(Te, { ...s });
      case "template3":
        return /* @__PURE__ */ t(Le, { ...s });
      case "template4":
        return /* @__PURE__ */ t(je, { ...s });
      default:
        return null;
    }
  }
);
re.displayName = "NewsletterTemplateSelector";
const Ee = "template2", Be = ce, Ue = x(
  "NewsletterSignup",
  m(
    {
      schema: Be,
      defaultProps: {
        template: "template2"
      }
    },
    (s) => {
      var o;
      const c = s || { template: Ee };
      return /* @__PURE__ */ t(
        se,
        {
          subscribeAttributes: (o = s.form) == null ? void 0 : o.subscribeAttributes,
          children: /* @__PURE__ */ t(re, { ...c })
        }
      );
    }
  )
), Xe = () => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    fill: "none",
    width: "16",
    height: "16",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ t(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
      }
    )
  }
);
export {
  U as AnimatedCheckIcon,
  Xe as CheckIcon,
  ne as FormStateContext,
  se as FormStateProvider,
  M as Heading,
  P as InputField,
  Ue as NewsletterSignup,
  Ie as NewsletterTemplate1,
  Te as NewsletterTemplate2,
  Le as NewsletterTemplate3,
  je as NewsletterTemplate4,
  re as NewsletterTemplateSelector,
  Pe as PhoneNumberField,
  E as SignupLists,
  B as SubmitButton,
  j as SubscriptionSuccess,
  W as TermsAndConditions,
  y as Text,
  Ae as ValidationError,
  Fe as errorSchema,
  _ as formSchema,
  Qe as formStateProviderSchema,
  k as headingSchema,
  H as inputFieldSchema,
  Ce as listIdSchema,
  Be as newsletterSignupPropsSchema,
  ie as newsletterTemplate1Schema,
  ae as newsletterTemplate2Schema,
  le as newsletterTemplate3Schema,
  oe as newsletterTemplate4Schema,
  ce as newsletterTemplateSelector,
  We as phoneNumberFieldSchema,
  ee as signupListsSchema,
  te as submitButtonSchema,
  xe as subscribeAttributesSchema,
  Y as subscriptionSuccessSchema,
  X as termsAndConditionsSchema,
  C as textSchema,
  N as useFormState
};
//# sourceMappingURL=index.es.js.map
